module.exports = __webpack_public_path__ + "img/flogo.7e6c0689.png";